export const AWS_QUERYSTRING_EXPIRE = 240; /* seconds */

/* Uploads and exports can run long on slow/high-latency connections, so they
 * override the default axios timeout. Value in milliseconds. */
export const LONG_REQUEST_TIMEOUT = 300000; /* 5 minutes */
